import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { config } from '../../shared/smartadmin.config';

@Injectable()
export class JsonApiService {

  constructor(private http: HttpClient) { }

  public fetch(url): Observable<any> {
    return this.http.get(this.getBaseUrl() + config.API_URL + url)
      .delay(100)
      .map((data: any) => (data.data || data))
      .catch(this.handleError)
  }

  private getBaseUrl() {
    // let resultado = location.protocol + '//' + location.hostname + (location.port ? ':'+location.port : '') + location.pathname + '#';
    const resultado = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + location.pathname;
    return resultado;
  }



  private handleError(error: any) {
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';

    console.error(errMsg); // log to console instead

    return Observable.throw(errMsg);
  }

}





// WEBPACK FOOTER //
// ./src/app/core/api/json-api.service.ts